import { fromJS } from 'immutable';

const components = {
	componentName: {
		componentKey: {
			id: 'componentState',
			open: true,
		},
	},
};

export default fromJS(components);
